import React, { useState, useEffect } from "react";
import './SearchableSelect.css'

const SearchableSelect = ({ options = [], onChange, placeholder = "Selecciona una opción" }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setFilteredOptions(
            options.filter((option) =>
                option.NOMBRE.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, options]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleOptionClick = (option) => {
        onChange(option); // Devuelve el objeto completo
        setSearchTerm(option.NOMBRE); // Muestra solo el nombre en el input
        setIsOpen(false);
    };

    return (
        <div className="searchable-select">
            <input
                type="text"
                value={searchTerm}
                placeholder={placeholder}
                onChange={handleSearchChange}
                onFocus={() => setIsOpen(true)}
                className="search-input"
            />
            {isOpen && (
                <div className="options-container">
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((option) => (
                            <div
                                key={option.ID_PERSONAL}
                                className="option"
                                onClick={() => handleOptionClick(option)}
                            >
                                {option.NOMBRE}
                            </div>
                        ))
                    ) : (
                        <div className="no-options">No hay opciones disponibles</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SearchableSelect;
